<template>
  <v-container class="d-flex flex-column ga-3">
    <UsageExample v-model="tab" :code="code" :tabs="tabs">
      <v-row>
        <v-col>
          <v-card elevation="4" class="pa-2 mx-auto" height="170" width="400">
            <v-card-title class="font-weight-bold">Text Input</v-card-title>
            <v-card-text>
              <hx-input-field
                v-model:input="inputValue"
                :label="label"
                :placeholder="placeholder"
                :additional-info="
                  showAdditionalInfo ? 'More information on input field' : undefined
                "
                :tooltip-direction="tooltipDirection"
                :helper-message="showHelperMessage ? 'Helper message' : undefined"
                :error-message="showErrorMessage ? 'Error message' : undefined"
                :optional="optional"
                :mandatory="mandatory"
                :disabled="disabled"
                @update:input="handleInputUpdate"
              >
              </hx-input-field>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <template #configuration>
        <div class="d-flex flex-column">
          <v-checkbox v-model="showAdditionalInfo" label="Additional Information" />
          <v-checkbox v-model="optional" label="Optional" />
          <v-checkbox v-model="mandatory" label="Mandatory" />
          <v-checkbox v-model="showHelperMessage" label="Helper Message" />
          <v-checkbox v-model="showErrorMessage" label="Error Message" />
          <v-checkbox v-model="disabled" label="Disabled" />
        </div>
      </template>
    </UsageExample>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixInputField',
  components: { UsageExample },

  setup() {
    const code = `
<hx-input-field
      label="Label"
      placeholder="Type input here"
      additional-info="More information on input field"
      tooltip-direction="right"
      helper-message="Helper message'"
      error-message="Error message"
      optional="false"
      mandatory="false"
      disabled="false"
  >
</hx-input-field>`;
    return {
      code
    };
  },

  data() {
    return {
      tab: 'Input Field Usage',
      tabs: ['Input Field Usage'],
      label: 'Label',
      placeholder: 'Type input here',
      showHelperMessage: false,
      showErrorMessage: false,
      optional: false,
      mandatory: false,
      showAdditionalInfo: false,
      disabled: false,
      tooltipDirection: 'right',
      inputValue: ''
    };
  },

  methods: {
    handleInputUpdate(value) {
      this.inputValue = value;
      console.log('Input value updated:', value);
    }
  }
};
</script>
